import React from "react";
import { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import AppContext from "../../../container/context";
import cfe from "../../../services/cfe";
import Form from "../../../components/form";

export default function Editar(props) {
  const [codigo] = useState(props.match.params.codigo);
  const { notification } = useContext(AppContext);
  const [tokenCadastro, setTokenCadastro] = useState({});
  const history = props.history;

  useEffect(() => {
    carregarUsuario();
  }, []);

  const carregarUsuario = () => {
    cfe
      .get("admin/tokensCadastro/carregar", { codigo: codigo })
      .then((res) => {
        res.expiracao =
          res.expiracao && new Date(res.expiracao).toLocaleDateString("pt-BR");
        setTokenCadastro(res);
      })
      .catch((err) => notification("error", "Erro ao carregar token"));
  };

  const excluirToken = () => {
    if (window.confirm("Confirma a excusão do token?") === true) {
      cfe
        .delete("admin/tokensCadastro/remover", {
          codigo: codigo,
        })
        .then((tokenSalvo) => {
          notification("warning", "Token excluído.");
          history.goBack();
        })
        .catch((err) => {
          console.log(err);
          notification(
            "warning",
            "Não foi possível excluir o token de cadastro."
          );
        });
    }
  };

  const fTokenCadastro = {
    title: "Dados do token",
    form: {
      instituicaoId: {
        label: "Instituição",
        type: "text",
        required: true,
        value: tokenCadastro.instituicaoNomeFantasia,
        // space: 6,
        readOnly: true,
      },
      usuarioNome: {
        label: "Nome do usuário a utilizar",
        type: "text",
        required: true,
        value: tokenCadastro.usuarioNome,
        space: 6,
        readOnly: true,
      },
      expiracao: {
        label: "Expira em",
        type: "text",
        value: tokenCadastro.expiracao,
        space: 6,
        readOnly: true,
      },
    },

    history,
    close: true,

    customActions: [
      {
        label: "Excluir",
        action: excluirToken,
      },
    ],
  };

  return (
    <>
      <Form formData={fTokenCadastro} />
    </>
  );
}
